/*
 * @Description: Echarts
 * @Author: lisenlin
 * @Date: 2021-08-27 01:02:29
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-27 01:02:29
 */
import React from 'react';
import ReactEchartsCore from "echarts-for-react/lib/core";
import echarts from "echarts/lib/echarts";

import 'echarts/lib/chart/line';
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import 'echarts/lib/chart/radar';
import 'echarts/lib/chart/map';
import 'echarts/lib/chart/graph';
import 'echarts/lib/chart/effectScatter';
import 'echarts/lib/chart/lines';

import "echarts/lib/component/legend";
import "echarts/lib/component/graphic";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/polar';
import 'echarts/lib/component/geo';

const Echarts = props => {
    return (
        <ReactEchartsCore
            style={{height: '100%', width:'100%'}}
            echarts={echarts}
            lazyUpdate={true}
            notMerge={true}
            {...props}
        />
    )
}

export default Echarts;


// WEBPACK FOOTER //
// ./components/common/Echarts/index.js